import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        base: '#3B1F2B',
        primary: '#db162f',
        secondary: '#DBDFAC',
        accent: '#5f758e',
        alert: '#383961',
        darkblue: "#1E2D56"
      }
    }
  }
});
